import { useTranslation } from 'react-i18next';
import { ExamLanding } from './ExamLanding';

// Referee "Video clip exams" landing — the video_clip_exam exams (scored on decision accuracy).
export function ClipExamsPage() {
  const { t } = useTranslation();
  return (
    <ExamLanding
      examType="video_clip_exam"
      title={t('exams.clipExamsPage.title')}
      subtitle={t('exams.clipExamsPage.subtitle')}
    />
  );
}
